<script setup>
import {useI18n} from 'vue-i18n';
import {ref} from 'vue';
import DomainSelectOverlay from '@/components/layouts/DomainSelectOverlay.vue';
import {Capacitor} from '@capacitor/core';
import {getAppDomain} from '@/helper';
import {appVersion} from '@/services/AppService';

const {t} = useI18n()
const showDomainSelect = ref(false);

if (getAppDomain() === null) {
  showDomainSelect.value = true;
}

emitter.on('domainOverlayClosed', () => {
  showDomainSelect.value = false;
});

</script>

<template>
  <DomainSelectOverlay v-if="showDomainSelect"></DomainSelectOverlay>
  <footer class="entrance__footer">
    <div class="container">
      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <div class="entrance__footer__text">
            <span>{{ t('footer.powered_by') }}</span> <span v-if="Capacitor.isNativePlatform()"><u class="cursor-pointer" @click="showDomainSelect = true">{{ t('footer.change_domain') }}</u></span>
            <small class="ms-2 text-muted opacity-50">v{{appVersion}}</small>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
